<template>
  <div class="showDataView">
     <el-button type="primary" size="small" class="btn" @click="showAddView.show = true">添加绑定关系</el-button>
      <el-table
        border
        :data="dataList"
        tooltip-effect="dark"
        style="width: 100%">
        <template slot="empty">
          <emptyView></emptyView>
        </template>
        <el-table-column
          prop="bindTime"
          label="绑定时间">
        </el-table-column>
         <el-table-column
          prop="bindNum"
          label="绑定数量">
        </el-table-column>
         <el-table-column
          label="操作">
          <template slot-scope="scope">
            <div>
              <span class="link" @click="getDetail(scope.row)">查看详情</span>
              <span class="link" @click="getDeviceCsvTemplate(scope.row)">下载CSV</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row :span="24" type="flex" justify="end">
        <div class="showAll"> 共<span>{{pageParams.total}}</span>个设备</div>
        <el-pagination
        :pager-count="11"
          layout="prev, pager, next"
          @current-change="currentPageChange"
          :page-size="pageParams.pageSize"
          :total="pageParams.total">
        </el-pagination>
      </el-row>
      <certificateBindDetailView
      :showDetailView="showDetailView"
      :certName="certDetail.certName"
      :detail="detail"
      :detailList="detailList"
      :pageParams="detailPageParams"
      @current-page-change="detailPageChange"
      @close-view="closeView">
      </certificateBindDetailView>
      <addCertificateBindView @close-view="showAddView.show = false" :registerCertId="certDetail.registerCertId" :showAddView="showAddView"></addCertificateBindView>
    </div>
</template>
<script>
import emptyView from '@/components/empty_view/empty'
import certificateBindDetailView from '@/components/product_control/certificateBindDetailView'
import addCertificateBindView from '@/components/product_control/addCertificateBindView'
import { bindCertInfo, queryCertsInfo, deviceCsvTemplate } from '@/api/productControl'
import { loadFileByUrl } from '@/utils'
export default {
  props: {
    certDetail: {
      type: Object
    }
  },
  components: {
    emptyView,
    certificateBindDetailView,
    addCertificateBindView
  },
  data () {
    return {
      dataList: [
        // { num: 1000, name: '文件名', id: '5555', time: '2012-10-12', endTime: '2012-12-12' }
      ],
      detailList: [],
      detail: {},
      showDetailView: {
        show: false
      },
      showAddView: {
        show: false
      },
      registerCertId: this.$route.query.registerCertId,
      pageParams: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      detailPageParams: {
        pageSize: 5,
        pageNum: 1,
        total: 0
      }
    }
  },
  methods: {
    closeView () {
      this.showDetailView.show = false
    },
    // 获取绑定证书的列表
    getBindCertInfo () {
      const params = {
        primaryId: this.registerCertId,
        pageSize: this.pageParams.pageSize,
        pageNum: this.pageParams.pageNum
      }
      bindCertInfo(params).then(res => {
        res = res.data
        res = res.data
        console.log('返回绑定证书列表：', res)
        this.pageParams.total = res.total
        console.log('bindCertInfo:', res)
        this.dataList = res.data
      })
    },
    getDetail (row) {
      this.detailPageParams.pageNum = 1
      this.getQueryCertsInfo(row)
    },
    // 获取每个列表项的详情
    getQueryCertsInfo (row) {
      console.log('详情：', row)
      const bindCertId = row ? row.bindCertId : this.detail.bindCertId
      const registerCertId = row ? row.registerCertId : this.detail.registerCertId
      const params = {
        bindCertId: bindCertId,
        registerCertId: registerCertId,
        pageSize: this.detailPageParams.pageSize,
        pageNum: this.detailPageParams.pageNum
      }
      console.log('查询发送参数：', params)
      queryCertsInfo(params).then(res => {
        res = res.data
        console.log('详情返回：', res)
        res.code === 200
          ? (
            this.showDetailView.show = true,
            this.detailList = res.data.data,
            this.detailPageParams.total = res.data.total,
            this.detail = row || this.detail
          )
          : this.$message.error(res.message)
      })
    },
    // 下载设备的csv模板
    getDeviceCsvTemplate (row) {
      const params = {
        bindCertId: row.bindCertId,
        registerCertId: row.registerCertId
      }
      deviceCsvTemplate(params).then(res => {
        res = res.data
        console.log('返回的下载数据：', res)
        if (res.data) {
          // window.open(res.data)
          loadFileByUrl(res.data)
        } else {
          this.$message.error('下载出错')
        }
      })
    },
    currentPageChange (num) {
      console.log('currentPageChange')
      this.pageParams.pageNum = num
      this.getBindCertInfo()
    },
    detailPageChange (listQuery) {
      Object.assign(this.detailPageParams, {
        pageSize: listQuery.limit,
        pageNum: listQuery.page
      })
      // console.log('detailPageChange:', num)
      // this.detailPageParams.pageNum = num
      this.getQueryCertsInfo()
    }
  },
  created () {
    this.getBindCertInfo()
  }
}
</script>
<style lang="less" scope>
.showDataView{
    margin-top: 10px;
    .link{
      color: #35a6df;
      cursor: pointer;
      margin-left: 10px;
    }
    .btn{
      margin-bottom: 10px;
    }
    .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
  }
</style>
